/* List of Redux constants */
export const USER_ACCOUNT_SET_USER_PROFILE_LOADING = '@user-account/profile/set-loading';
export const USER_ACCOUNT_SET_USER_PROFILE = '@user-account/profile/set-user-profile';
export const USER_ACCOUNT_RESET_USER_PROFILE_STATE = '@user-account/profile/reset-state';
export const USER_ACCOUNT_SET_USER_PROFILE_UPDATING = '@user-account/profile/set-updating';
export const USER_ACCOUNT_SET_UPDATING_PASSWORD = '@user-account/set-updating-password';
export const USER_ACCOUNT_SET_UPDATE_PASSWORD_ERROR = '@user-account/set-update-password-error';
export const USER_ACCOUNT_SET_SETTINGS_UPDATING = '@user-account/set-settings-updating';
export const USER_ACCOUNT_SET_UPDATING_EMAIL = '@user-account/user-email/set-updating-email';
export const USER_ACCOUNT_SET_UPDATE_EMAIL_ERROR = '@user-account/user-email/set-error';
export const USER_ACCOUNT_RESET_USER_UPDATE_EMAIL_STATE = '@user-account/user-email/reset-state';

/* List of Sagas constants */
export const USER_ACCOUNT_FETCH_CURRENT_ADMINISTRATOR_PROFILE = '@user-account/profile/fetch-current-administrator-profile';
export const USER_ACCOUNT_FETCH_CURRENT_SCHOOL_USER_PROFILE = '@user-account/profile/fetch-current-school-user-profile';
export const USER_ACCOUNT_UPDATE_CURRENT_ADMINISTRATOR_PROFILE = '@user-account/profile/update-current-administrator-profile';
export const USER_ACCOUNT_UPDATE_PASSWORD = '@user-account/update-password';
export const USER_ACCOUNT_UPDATE_SETTINGS = '@user-account/update-settings';
export const USER_ACCOUNT_UPDATE_EMAIL = '@user-account/user-email/update-email';



// WEBPACK FOOTER //
// ./src/actions/user-account/types.js